import React from "react";
import { AutocompleteInput, ReferenceInput, SelectInput } from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import SearchInput from "../components/inputs/SearchInput";

const Filters = ({ isAdmin, ...props }) => {
	return (
		<SubmitFilters {...props}>
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="bookmaker_type_id"
				reference="bookmaker-types"
				alwaysOn
				fullWidth
				emptyText="ra.action.all"
				allowEmpty
			>
				<SelectInput optionText="name" style={{ minWidth: 256 }} />
			</ReferenceInput>
			{isAdmin && (
				<ReferenceInput
					source="user_id"
					reference="users"
					alwaysOn
					fullWidth
					emptyText="ra.action.all"
					allowEmpty
				>
					<AutocompleteInput optionText="name" style={{ minWidth: 256 }} />
				</ReferenceInput>
			)}
		</SubmitFilters>
	);
};
export default Filters;
